import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { Avatar, Link } from '@infl-ts/ui-advocate-components';
import { formatDistanceStrictShort, getLocale } from '@infl-ts/util-date';
import { useToggle } from '@infl-ts/util-hooks';
import { useLanguage } from '@infl-ts/util-i18n-provider';
import { useMinimizeChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { parseISO } from 'date-fns';
import * as DATE from 'fp-ts/Date';
import { pipe } from 'fp-ts/function';
import { useTranslation } from 'react-i18next';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var UnderlinedText = function UnderlinedText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Box, {
    component: "span",
    sx: {
      textDecoration: 'underline'
    },
    "data-element": "Box",
    "data-component": "UnderlinedText",
    "data-source-file": "index.tsx",
    children: children
  });
};

var TopicCard = function TopicCard(_ref2) {
  var topic = _ref2.topic;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Card, {
    "data-element": "Card",
    "data-component": "TopicCard",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsxs(CardContent, {
      sx: {
        p: 3,
        display: 'flex',
        flexDirection: 'row',
        gap: 4
      },
      "data-element": "CardContent",
      "data-component": "TopicCard",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Avatar, {
        sx: {
          width: 48,
          height: 48
        },
        member: topic.author,
        disabledPopover: true,
        "data-element": "Avatar",
        "data-component": "TopicCard",
        "data-source-file": "index.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        "data-element": "Box",
        "data-source-file": "index.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          sx: {
            fontWeight: function fontWeight(t) {
              return t.typography.fontWeightBold;
            }
          },
          "data-element": "Typography",
          "data-source-file": "index.tsx",
          children: topic.title
        }), /*#__PURE__*/_jsxs(Typography, {
          component: "span",
          variant: "caption",
          sx: {
            display: 'flex',
            alignItems: 'baseline',
            color: function color(t) {
              return t.palette.text.secondary;
            },
            a: {
              color: function color(t) {
                return t.palette.text.secondary;
              },
              fontWeight: function fontWeight(t) {
                return t.typography.fontWeightRegular;
              }
            }
          },
          "data-element": "Typography",
          "data-source-file": "index.tsx",
          children: ["by\xA0", /*#__PURE__*/_jsx(UnderlinedText, {
            "data-element": "UnderlinedText",
            "data-source-file": "index.tsx",
            children: topic.author.name
          }), "\xA0\xB7\xA0", pipe(topic.createdAt, parseISO, formatDistanceStrictShort(DATE.create(), t, {
            locale: getLocale(currentLang)
          })), "\xA0\xB7\xA0", /*#__PURE__*/_jsx(UnderlinedText, {
            "data-element": "UnderlinedText",
            "data-source-file": "index.tsx",
            children: topic.category.name
          })]
        })]
      })]
    })
  });
};

var DiscussionReply = function DiscussionReply(_ref3) {
  var stage = _ref3.stage,
      prospect = _ref3.prospect;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      hasGoneToReply = _useToggle2[0],
      setGoneToReply = _useToggle2[1].on;

  var discourseUrl = useMinimizeChallengePlayer(stage.url);

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(Button, {
      component: Link,
      disabled: hasGoneToReply,
      href: discourseUrl,
      onClick: setGoneToReply,
      variant: "contained",
      children: hasGoneToReply ? t('Processing your response') : stage.completionText || t('Reply to Discussion')
    }),
    "data-element": "StageLayout",
    "data-component": "DiscussionReply",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Link, {
      sx: {
        '&:hover': {
          textDecoration: 'none'
        }
      },
      onClick: setGoneToReply,
      href: discourseUrl,
      "data-element": "Link",
      "data-component": "DiscussionReply",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx(TopicCard, {
        topic: stage.topic,
        "data-element": "TopicCard",
        "data-component": "DiscussionReply",
        "data-source-file": "index.tsx"
      })
    })
  });
};

export default DiscussionReply;